import { ConsumerPortalPaymentMethods } from "features/consumerPortalPaymentMethods";

export default function PaymentMethodsPage() {
  return <ConsumerPortalPaymentMethods />;
}
